import React from 'react'
import * as S from './styles'

export const ProductRow = ({ product, BatchesTable, headerColor }) => {
  return (
      <S.ProductWrapper>
          <BatchesTable product={product}  headerColor={headerColor} />
      </S.ProductWrapper>
  )
}
